import script from "./generic-accordion.vue?vue&type=script&lang=ts&setup=true"
export * from "./generic-accordion.vue?vue&type=script&lang=ts&setup=true"

import "./generic-accordion.vue?vue&type=style&index=0&id=5e0b9dce&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e0b9dce"]])

export default __exports__